module.exports = __webpack_public_path__ + "img/providers-ellipsis.7809998f.png";